import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';

const advantages = [
  {
    title: "Producers",
    description: "Small and large farms, Indigenous growers, and food co-ops benefit from edge-enabled monitoring and automation tools that require no cloud dependency or extensive IT investment.",
  },
  {
    title: "Agri-Food Processors",
    description: "Easily embed our platform with temperature sensors, storage equipment, and QA systems to improve traceability, reduce spoilage, and ensure regulatory compliance.",
  },
  {
    title: "AgTech Startups & Solution Providers",
    description: "Leverage our SDKs and APIs to rapidly integrate AI features into your platforms, including predictive maintenance, yield forecasting, and real-time crop diagnostics.",
  },
  {
    title: "IoT & Sensor Vendors",
    description: "Our platform's modular architecture allows direct plug-in of your sensors and controllers-bridging data collection with localized AI processing.",
  },
  {
    title: "Distributors & Logistics Operators",
    description: "Use AI models for cold chain monitoring, inventory optimization, and quality control in transit-supporting safety and transparency from field to shelf.",
  },
  {
    title: "Academic & Research Institutions",
    description: "Collaborate with our platform as a testbed for applied research in sustainable agriculture, edge computing, and climate-smart food systems-supporting innovation, commercialization, and workforce development.",
  },
]

const Advantage = () => {
  return (
    <>
      <Element
        name="Advantage"
        className="datatalent-section-gap solutions-advantage"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center text-white"
                title = "Agriculture & Food Ecosystem Integration"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center color-white">Seamless AI + IoT integration across the agri-food value chain.</p>
            </div>
            {advantages.map((adv) =>
              <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={adv.title}>
                <div className="advantage-card p-4 h-100">
                  <h5 className="mt-3 mb-3 color-white">{adv.title}</h5>
                  <p className="mb-3">{adv.description}</p>
                </div>
            </div>
            )}
          </div>
        </div>
      </Element>
    </>
  )
}

export default Advantage;